// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"60":"87cc60dc","317":"87cc60dc"}[chunkId] + ".chunk.css";
};